var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassHideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.585 10.587C10.21 10.9622 9.99936 11.4709 9.99945 12.0014C9.99954 12.5318 10.2104 13.0405 10.5855 13.4155C10.9607 13.7905 11.4694 14.0012 11.9999 14.0011C12.5303 14.001 13.039 13.7902 13.414 13.415M16.681 16.673C15.2782 17.5507 13.6547 18.0109 12 18C8.4 18 5.4 16 3 12C4.272 9.88 5.712 8.322 7.32 7.326M10.18 6.18C10.779 6.05873 11.3888 5.99842 12 6C15.6 6 18.6 8 21 12C20.334 13.11 19.621 14.067 18.862 14.87M3 3L21 21",
    stroke: "#F7A600 ",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassHideIcon);
export default __webpack_public_path__ + "static/media/passHideIcon.c9e011f41eaf5cea33905354b1a41448.svg";
export { ForwardRef as ReactComponent };